import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useMemo } from 'react';
import classNames from 'classnames';
import { Typography, Box, FileDropzone } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import ExternalLinkButton from '~/components/ExternalLinkButton';
import { useLocaleKeys } from '~/i18n';
import styles from './UploadContainer.module.scss';
export const GetUploadContainerTID = (parentTestId)=>getTestIds(parentTestId);
export const UploadContainer = (param)=>{
    let { error, uploadFile } = param;
    const { t: gbhTexts } = useLocaleKeys('billing.globalHub');
    const { UploadContainerTestIds } = useMemo(()=>GetUploadContainerTID(), []);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs(Box, {
                className: styles.uploadContainerWrapper,
                children: [
                    /*#__PURE__*/ _jsx(FileDropzone, {
                        bi: {
                            name: 'bulk_billing_upload'
                        },
                        accept: ".csv",
                        testId: UploadContainerTestIds.Container(),
                        inputTestId: UploadContainerTestIds.Input(),
                        onFileSelected: uploadFile,
                        className: classNames(styles.uploadContainer, {
                            [styles.error]: !!error
                        }),
                        renderContent: (param)=>{
                            let { isDragging } = param;
                            return /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    isDragging && /*#__PURE__*/ _jsx(Box, {
                                        className: classNames(styles.uploadContainerDragging, {
                                            [styles.display]: isDragging
                                        }),
                                        children: /*#__PURE__*/ _jsx(Typography, {
                                            skin: "secondary",
                                            variant: "h4",
                                            children: gbhTexts.dropCsvFile()
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(Box, {
                                        className: styles.uploadContainerContent,
                                        children: /*#__PURE__*/ _jsxs(Box, {
                                            children: [
                                                /*#__PURE__*/ _jsx(Typography, {
                                                    as: "span",
                                                    skin: "link",
                                                    children: gbhTexts.chooseCsvFile()
                                                }),
                                                ' ',
                                                /*#__PURE__*/ _jsx(Typography, {
                                                    as: "span",
                                                    skin: "secondary",
                                                    children: gbhTexts.uploadLineItems()
                                                })
                                            ]
                                        })
                                    })
                                ]
                            });
                        }
                    }),
                    error && /*#__PURE__*/ _jsx(Typography, {
                        skin: "error",
                        testId: UploadContainerTestIds.Error(),
                        children: error
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Box, {
                className: styles.downloadExample,
                children: /*#__PURE__*/ _jsx(ExternalLinkButton, {
                    testId: UploadContainerTestIds.DownloadExample(),
                    href: "https://storage.googleapis.com/anchor-statics/Anchor_Bulk_Bill/2025-06-18/Anchor_Bulk_Bill.zip",
                    className: styles.downloadLink,
                    bi: {
                        name: 'bulk_billing_download_example_file'
                    },
                    children: gbhTexts.downloadExampleFile()
                })
            })
        ]
    });
};
